module.exports = __webpack_public_path__ + "756796647b60be398a7575a7fbe0ba9d.png";